import React from 'react';
import { CollapsiblePanel, EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, PanelBody, Tray } from '../../components/elements';
import { ISurveyTemplateManifestationData } from '../../components/Surveys/ISurveyTemplateManifestationData';
import { getOpenApiRouteItemUrlValidatingElements } from '../../components/validatingComponents/getOpenApiRouteItemUrlValidatingElements';
import { ValidatingEditPanelSaveButton } from '../../components/validatingElements';
import { useTranslate } from '../../mixins/translate/translate';
import { crowBeeldkwaliteitSelectOptions } from './crowBeeldkwaliteitSelectOptions';

const validatingElements = getOpenApiRouteItemUrlValidatingElements(
    '/api/surveys/{surveyId}/manifestations/{manifestationId}/inspectionStandardData/crowBeeldkwaliteit',
    'post',
);

export function SurveyEditCrowBeeldkwaliteitManifestationResult(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & ISurveyTemplateManifestationData,
) {
    const translate = useTranslate();

    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <CollapsiblePanel
                    heading={{ dark: true, text: `${translate('crowBeeldkwaliteit.crowBeeldkwaliteit')} - ${props.manifestationName}` }}
                >
                    <PanelBody isForm={true}>
                        <validatingElements.ItemUrlForm
                            onSubmitted={props.onItemChanged}
                            routeParams={{
                                surveyId: props.surveyId,
                                manifestationId: props.manifestationId,
                            }}
                        >
                            <EditPanelRow>
                                <EditPanelCell rowCount={12}>
                                    {' '}
                                    <validatingElements.FilterDropdown
                                        name="crowScore"
                                        selectOptions={crowBeeldkwaliteitSelectOptions.crowScore}
                                        topLabel="Beoordeling"
                                    />{' '}
                                </EditPanelCell>
                            </EditPanelRow>
                            <EditPanelRow>
                                <EditPanelCell rowCount={12}>
                                    <validatingElements.TextArea name="remarks" topLabel={translate('common.remarks')} />
                                </EditPanelCell>
                            </EditPanelRow>
                            <EditPanelButtons>
                                <ValidatingEditPanelSaveButton small={true} />
                            </EditPanelButtons>
                        </validatingElements.ItemUrlForm>
                    </PanelBody>
                </CollapsiblePanel>
            </EditPanel>
        </Tray>
    );
}
